import React from "react";
import styled from "styled-components";
import HomeIcon from "@mui/icons-material/Home";
import ExploreOutlinedIcon from "@mui/icons-material/ExploreOutlined";
import SubscriptionsOutlinedIcon from "@mui/icons-material/SubscriptionsOutlined";
import VideoLibraryOutlinedIcon from "@mui/icons-material/VideoLibraryOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import LibraryMusicOutlinedIcon from "@mui/icons-material/LibraryMusicOutlined";
import SportsEsportsOutlinedIcon from "@mui/icons-material/SportsEsportsOutlined";
import SportsBasketballOutlinedIcon from "@mui/icons-material/SportsBasketballOutlined";
import MovieOutlinedIcon from "@mui/icons-material/MovieOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import LiveTvOutlinedIcon from "@mui/icons-material/LiveTvOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import SettingsBrightnessOutlinedIcon from "@mui/icons-material/SettingsBrightnessOutlined";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const Container = styled.div`
  flex: 1;
  background-color: ${({ theme }) => theme.bgLighter};
  height: 100vh;
  color: ${({ theme }) => theme.text};
  font-size: 14px;
  position: sticky;
  top: 56px;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 7px;
    background-color: #8e9e9e;
    border-radius: 5px;
  }

  display: ${({ menuHide }) => (menuHide ? "none" : "flex")};
  @media only screen and (max-width: 1024px) {
    display: none;
    flex: 0;
  }
`;

const Wrapper = styled.div`
  padding: 18px 26px;
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  cursor: pointer;
  padding: 7.5px 0px;
  &:hover {
    background-color: ${({ theme }) => theme.soft};
  }
`;

const Hr = styled.hr`
  margin: 15px 0px;
  border: 0.5px solid ${({ theme }) => theme.soft};
`;

const Login = styled.div``;
const Button = styled.button`
  padding: 5px 15px;
  background-color: transparent;
  border: 1px solid #3ea6ff;
  color: #3ea6ff;
  border-radius: 3px;
  font-weight: 500;
  margin-top: 10px;
  cursor: pointer;
  align-items: center;
  display: flex;
  gap: 5px;
`;

const Title = styled.h2`
  font-size: 14px;
  font-weight: 500;
  color: #aaaaaa;
  margin-bottom: 20px;
`;

const Menu = ({ darkMode, setDarkMode }) => {
  const { currentUser } = useSelector((state) => state.user);
  const { menuHide } = useSelector((state) => state.menu);

  return (
    <Container menuHide={menuHide}>
      <Wrapper>
        <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
          <Item>
            <HomeIcon />
            Home
          </Item>
        </Link>
        <Link to="/trend" style={{ textDecoration: "none", color: "inherit" }}>
          <Item>
            <ExploreOutlinedIcon />
            Explore
          </Item>
        </Link>
        <Link
          to="/sub"
          style={{
            textDecoration: currentUser ? "none" : "none",
            color: currentUser ? "inherit" : "inherit",
          }}
        >
          <Item
            style={{
              cursor: currentUser ? "pointer" : "not-allowed",
            }}
          >
            <SubscriptionsOutlinedIcon />
            Subscriptions
          </Item>
        </Link>
        <Item onClick={() => setDarkMode(!darkMode)}>
          <SettingsBrightnessOutlinedIcon />
          {darkMode ? "Light" : "Dark"} Mode
        </Item>
        <Hr />
        <Item style={{ cursor: "not-allowed" }}>
          <VideoLibraryOutlinedIcon />
          Library
        </Item>
        <Item style={{ cursor: "not-allowed" }}>
          <HistoryOutlinedIcon />
          History
        </Item>
        <Hr />
        {!currentUser && (
          <>
            <Login>
              Sign in to like videos, comment, and subscribe.
              <Link to="signin" style={{ textDecoration: "none" }}>
                <Button>
                  <AccountCircleOutlinedIcon />
                  SIGN IN
                </Button>
              </Link>
            </Login>
            <Hr />
          </>
        )}

        <Title>BEST OF MOUDTUBE</Title>
        <Item style={{ cursor: "not-allowed" }}>
          <LibraryMusicOutlinedIcon />
          Music
        </Item>
        <Item style={{ cursor: "not-allowed" }}>
          <SportsBasketballOutlinedIcon />
          Sports
        </Item>
        <Item style={{ cursor: "not-allowed" }}>
          <SportsEsportsOutlinedIcon />
          Gaming
        </Item>
        <Item style={{ cursor: "not-allowed" }}>
          <MovieOutlinedIcon />
          Movies
        </Item>
        <Item style={{ cursor: "not-allowed" }}>
          <ArticleOutlinedIcon />
          News
        </Item>
        <Item style={{ cursor: "not-allowed" }}>
          <LiveTvOutlinedIcon />
          Live
        </Item>
        <Hr />
        <Item style={{ cursor: "not-allowed" }}>
          <SettingsOutlinedIcon />
          Settings
        </Item>
        <Item style={{ cursor: "not-allowed" }}>
          <FlagOutlinedIcon />
          Report
        </Item>
        <Item style={{ cursor: "not-allowed" }}>
          <HelpOutlineOutlinedIcon />
          Help
        </Item>
      </Wrapper>
    </Container>
  );
};

export default Menu;
